import { Breakpoint } from "@mui/material";
import { EventRecordType } from "pages/Event/Event.types";
import { AttendeeRecordType } from "pages/SharedRecords.types";
import { createContext } from "react";

type AttendeeContextType = {
  attendees: AttendeeRecordType[];
  setAttendees: (content: AttendeeRecordType[]) => void;
};

export const AttendeeContext = createContext<AttendeeContextType>({
  attendees: [],
  setAttendees: () => {},
});

type EventContextType = {
  event?: EventRecordType;
  setEvent: (content?: EventRecordType) => void;
};

export const EventContext = createContext<EventContextType>({
  event: undefined,
  setEvent: () => {},
});

type DialogWidthContextType = {
  dialogMaxWidth: Breakpoint;
  setDialogMaxWidth: (maxWidth: Breakpoint) => void;
};

export const DialogWidthContext = createContext<DialogWidthContextType>({
  dialogMaxWidth: "sm",
  setDialogMaxWidth: () => {},
});
